module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Unterlunkhofen-64940b3d434e3e57ad415b2693e380fd.svg";